import { Navigate, Outlet } from 'react-router-dom'
import { FullScreenSpinner } from '@/components/routing/FullScreenSpinner'
import { useAuthStore } from '@/store/authStore'

export function AdminRoute() {
  const { isAuthenticated, isLoading, user } = useAuthStore()

  if (isLoading) return <FullScreenSpinner />
  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (!user?.admin) return <Navigate to="/" replace />

  return <Outlet />
}
